import { useDispatch } from 'react-redux';
import { fetchCartWishlistSearch } from '@client/cart/redux/wishlistSearch/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useFetchCartWishlistSearchAction = (): typeof fetchCartWishlistSearch => {
  const dispatch = useDispatch();

  return bindActionCreators(fetchCartWishlistSearch, dispatch);
};
